import { useFrontVersion } from 'utils/version';

export function SocGenLogo(): React.JSX.Element {
  const version = useFrontVersion();

  return (
    <a className="navbar-title-link" title={version}>
      <div className="navbar-logo">
        <svg height={24} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect x="0" y="0" width="32" height="32" fill="white"></rect>
          <rect x="1" y="1" width="30" height="15" fill="var(--bs-socgen)"></rect>
          <rect x="1" y="16" width="30" height="15" fill="black"></rect>
          <rect x="6" y="15" width="20" height="2" fill="white"></rect>
        </svg>
      </div>
      <div className="navbar-title-divider"></div>
      <div className="navbar-service-name">
        Structured
        <br />
        Products
      </div>
    </a>
  );
}

SocGenLogo.displayName = 'SocGenLogo';
